<template>
    <div>
        <div class="content-caption dashed">
            <span>所需组装信息</span>
        </div>
        <div class="table-layout">
            <el-table :data="devcAccAsmblRelList" border style="width: 100%">
                <el-table-column prop="name" label="名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="catName" label="分类" width="150" align="center"></el-table-column>
                <el-table-column prop="brandName" label="品牌" width="150" align="center"></el-table-column>
                <el-table-column prop="model" label="型号" width="160" align="left"></el-table-column>
                <el-table-column prop="fixedSpec" label="规格" width="160" align="left"></el-table-column>
                <el-table-column prop="accCount" label="所需数量" width="120" align="left"></el-table-column>
            </el-table>
        </div>
        <div class="content-caption dashed">
            <span>已组装信息</span>
        </div>
        <div class="table-layout">
            <el-table :data="selectAccAsmblRelList" border style="width: 100%">
                <el-table-column prop="name" label="名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="catName" label="分类" width="150" align="left"></el-table-column>
                <el-table-column prop="brandName" label="品牌" width="150" align="left"></el-table-column>
                <el-table-column prop="modelSpec" label="型号规格" width="150" align="left"></el-table-column>
                <el-table-column prop="theUnit" label="单位" width="80" align="center"></el-table-column>
                <el-table-column prop="price" label="价格(元)" width="100" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.price != null">{{rows.row.price.toFixed(2)}}</span>
                        <span v-else>0.00</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sellerName" label="供应商" width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="recvVoucherNo" label="收货单号" width="200" align="center"></el-table-column>
                <el-table-column prop="receiveTime" label="收货时间" width="150" align="center"></el-table-column>
                <el-table-column prop="stockQuantity" label="库存数量" width="90" align="right"></el-table-column>
                <el-table-column prop="upQuantity" label="已使用数量" width="90" align="right"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import asmblAccApi from '../../api/asmblAcc'
    import devcDefApi from '../../api/devcDef'
    import shopDevcApi from '../../api/shopDevc'

    export default {
        name: 'swb-shop-asmbl-acc-io-rec-set',
        desc: '组装件库存',
        props: {
            shopDevcId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                devcAccAsmblRelList: [],
                selectAccAsmblRelList: [],
            }
        },
        created: function () {
            this.getShopDeviceSvcSubNo();
            //
            this.getAsmblAccListForDevice();
        },
        methods: {
            getShopDeviceSvcSubNo: function () {
                let self = this;
                let postData = {};
                postData.id = self.shopDevcId;
                let theLoad = MsgBox.loading();
                shopDevcApi.getShopDeviceSvcSubNoById(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        let shopDeviceSubNo = result.data;
                        if(shopDeviceSubNo.devcDefId != -1) {
                            self.getAsmblAccDefList(shopDeviceSubNo.devcDefId);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 关联管理（要求）
            getAsmblAccDefList(devcDefId){
                let self = this;
                let postData = {
                    devcDefId: devcDefId
                };
                let theLoading = MsgBox.loading();
                devcDefApi.getAsmblAccDefList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        self.devcAccAsmblRelList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取已经设置的组装件信息
            getAsmblAccListForDevice: function () {
                let self = this;
                let postData = {
                    shopDevcId: this.shopDevcId
                };
                let theLoading = MsgBox.loading();
                asmblAccApi.getShopAsmblAccIoRecList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        let selectAccAsmblRelList = result.data || [];
                        for(let i = 0; i < selectAccAsmblRelList.length; i++) {
                            let asmblAccRel = selectAccAsmblRelList[i];
                            asmblAccRel.upQuantity = asmblAccRel.quantity;
                            asmblAccRel.quantity = 0;
                        }
                        self.selectAccAsmblRelList = Utils.merge([], selectAccAsmblRelList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ShopAsmblAccIoRecSet.vue